/**
 * Public password reset page — /reset-password?token=xxx
 */
import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import BrandMark from "@/components/BrandMark";
import AuthLegalFooter from "@/components/legal/AuthLegalFooter";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [ok, setOk] = useState(false);

  useEffect(() => {
    if (!token) toast.error("Missing reset token");
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return toast.error("Password must be 6+ characters");
    if (pw !== pw2) return toast.error("Passwords don't match");
    setBusy(true);
    try {
      await axios.post(`${API}/auth/password-reset/confirm`, { token, new_password: pw });
      setOk(true);
      toast.success("Password reset. Log in with your new password.");
      setTimeout(() => navigate("/login"), 1200);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Reset failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col" data-testid="reset-password-page">
      <div className="flex-1 flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-card border border-border rounded-2xl p-8">
        <BrandMark size={48} className="rounded-lg mb-4" />
        <h1 className="font-display text-2xl font-bold mb-1">Reset your password</h1>
        <p className="text-sm text-muted-foreground mb-6">Choose a new password for your Career OS account.</p>
        {ok ? (
          <div className="text-emerald-500 text-sm">Password updated. Redirecting to login…</div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <input type="password" placeholder="New password" value={pw} onChange={(e) => setPw(e.target.value)} className="w-full bg-background border border-border rounded-md px-4 py-3 text-sm outline-none focus:border-primary" data-testid="reset-pw" required />
            <input type="password" placeholder="Confirm password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="w-full bg-background border border-border rounded-md px-4 py-3 text-sm outline-none focus:border-primary" data-testid="reset-pw-confirm" required />
            <button type="submit" disabled={busy || !token} className="w-full bg-primary text-primary-foreground py-3 rounded-md font-semibold text-sm disabled:opacity-50" data-testid="reset-submit">
              {busy ? "Updating…" : "Update password"}
            </button>
          </form>
        )}
      </div>
      </div>
      <AuthLegalFooter />
    </div>
  );
}
